import { ALLOW_EDIT } from '../../../utils/OperationPermissions';

const SalesTransactionEnquiry = {
  type: 'MinMaxCalculationParametersInput', //Not sure why - Brought over from SalesControlTotalsForm.js to avoid breaking it.
  formTitle: 'Sales Ledger Control Totals',
  formUrl: '/Customers/ControlTotals/',
  screenReference: 'SALES_LEDGER_CONTROLTOTALS',
  operations: ALLOW_EDIT,
};

export default SalesTransactionEnquiry;
